import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Output } from '@angular/core';

export interface ConfirmationDialogOptions {
  title: string;
  message: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  confirmButtonClass?: string;
  dangerMode?: boolean;
  data?: any; // Optional data to pass back with confirmation
}

@Component({
  selector: 'app-confirmation-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss',
})
export class ConfirmationDialogComponent {
  isVisible = false;

  // Dialog options with defaults
  title = 'Confirm Action';
  message = 'Are you sure you want to proceed?';
  confirmButtonText = 'Confirm';
  cancelButtonText = 'Cancel';
  confirmButtonClass = 'btn-primary';
  dangerMode = false;
  data: any = null;

  @Output() confirmed = new EventEmitter<any>();
  @Output() cancelled = new EventEmitter<void>();

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (this.isVisible && event.key === 'Escape') {
      this.close();
    }
  }

  /**
   * Opens the confirmation dialog
   * @param options Configuration options for the dialog
   */
  open(options: ConfirmationDialogOptions): void {
    this.title = options.title;
    this.message = options.message;
    this.confirmButtonText = options.confirmButtonText || 'Confirm';
    this.cancelButtonText = options.cancelButtonText || 'Cancel';
    this.confirmButtonClass = options.dangerMode ? 'btn-danger' : (options.confirmButtonClass || 'btn-primary');
    this.dangerMode = options.dangerMode || false;
    this.data = options.data;
    this.isVisible = true;
  }

  /**
   * Confirms the action and emits the confirmed event
   */
  confirm(): void {
    this.confirmed.emit(this.data);
    this.isVisible = false;
  }

  /**
   * Cancels the dialog and emits the cancelled event
   */
  close(): void {
    this.cancelled.emit();
    this.isVisible = false;
  }
}
